jQuery(document).ready(function($){
    // Read More button on /pages/entrepreneurs-and-stories
    $('.read_more_btn').on('click', function(e){
        e.preventDefault();
        $(this).hide();
        $(this).next('.es-story-text').slideDown();
    })

    // Home page top banner slider
    $('.image_slider').owlCarousel({
      navigation : true, // Show next and prev buttons
      slideSpeed : 300,
      paginationSpeed : 400,
      items : 1, 
      itemsDesktop : false,
      itemsDesktopSmall : false,
      itemsTablet: false,
      itemsMobile : false,
      dots: true
    })
    
	//blog page slider
    $('div#shopify-section-blog-column .stories-wrapper').owlCarousel({
      navigation : true, // Show next and prev buttons
      slideSpeed : 300,
      paginationSpeed : 400,
      items : 3, 
      itemsDesktop : false,
      itemsDesktopSmall : false,
      dots: true,
      responsiveClass:true,
        responsive:{
            600:{
                items:1
            },
            991:{
                  items:2
              }
        }
    })
})